<template>
  <div ref="noticeTop">
    <div v-if="!showNoticeDetail">
      <div>
        <h2 class="section-title m-4 text-center text-lg">ご意見・ご要望等</h2>
        <p @click="getQuestionnaire()" class="bg-white p-4 border-b border-section_border font-bold text-link_darker text-blue-700 underline">お問い合わせフォームはこちら</p>
      </div>
      <h2 class="section-title m-4 text-center text-lg">おしらせ</h2>
      <div v-if="notice.length > 0">
        <ul class="p-4 border-b border-section_border">
          <li v-for="message in notice" :key="message.id" class="course">
            <div @click="getDetail(message)" class="bg-white w-full border-b p-2">
              <div v-if="isUnread(message)" class="float-left bg-yellow-300 px-1 mt-1 mr-2 text-xs">NEW</div>
              <p class="text-left">{{ getMoment(message.dispDate) }}</p>
              <p class="font-bold text-link_darker text-left">{{ message.title }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  <div v-else class="h-full w-full">
      <notice-detail :message="message" @backNotice="backNotice"/>
    </div>
  </div>
</template>
  
  <script>
  import { mapGetters } from 'vuex'
  import moment from "moment";
  import NoticeDetail from '../components/organisms/NoticeDetail';
  import Constants from "../constants"
  
  export default {
    components: { NoticeDetail },
    data () {
      return {
        showNoticeDetail: false,
        message: {}
      }
    },
    name: 'Notice',
    mounted() {
      this.$store.dispatch('notice/fetchAll')
    },
    computed: {
      ...mapGetters({
        notice: 'notice/getAll',
        alreadyRead: 'notice/getAlreadyRead'
      })
    },
    methods: {
      getDetail: function (message) {
        this.$store.dispatch('notice/updateAlreadyRead', message.id)
        this.message = message
        this.showNoticeDetail = true
        this.$refs['noticeTop'].scrollIntoView({ behavior: 'smooth'})
      },
      getMoment: function (date) {
        return moment(date).format('YYYY/MM/DD')
      },
      backNotice: function () {
        this.showNoticeDetail = false
        this.$refs['noticeTop'].scrollIntoView({ behavior: 'smooth'})
      },
      getQuestionnaire: function () {
        window.open(Constants.QUESTIONNAIRE_URL)
      },
      isUnread: function (message) {
        return !this.alreadyRead.includes(message.id)
      }
    }
  }
  </script>